export function serializeForm(form) {
  let result = {}
  for (let key in form) {
    const field = form[key]
    if (key === 'slaves') {
      result[key] = serializeSlavesField(field)
    } else if (key === 'result') {
      result[key] = serializeResultField(field)
      // send empty array if configuration object is empty
    } else if (key === 'configuration' && field.data === '') {
      result[key] = field.data || []
    } else if (key === 'dust_threshold' && isBonusCurrencyMap(field)) {
      result[key] = serializeBonusCurrencyMap(field)
    } else if (field.hasOwnProperty('data')) {
      result[key] = field.data
    } else if (isArray(field)) {
      result[key] = serializeArray(field)
    } else if (isMultiCheckbox(field)) {
      result[key] = serializeMultiCheckbox(field)
    } else {
      result[key] = serializeForm(field)
    }
  }
  return result
}

export function serializeMultiCheckbox(field) {
  return Object.keys(field).reduce((arr, index) => {
    return field[index].data ? [...arr, index] : arr
  }, [])
}

export function serializeArray(field) {
  return field.reduce((arr, item) => {
    if (item.data) {
      return [...arr, item.label]
    } else {
      return arr
    }
  }, [])
}

export function serializeSlavesField(field) {
  const recordSlaves = (item) => {
    let newItem = {}
    for (let propName in item) {
      if (hasOwnProperty.call(item, propName)) {
        newItem[propName] = item[propName].data
      }
    }
    return newItem
  }
  if (field.data) {
    return field.data.map(item => {
      return recordSlaves(item)
    })
  } else {
    return field.map(item => {
      return recordSlaves(item)
    })
  }
}

export function serializeResultField(field) {
  let data
  if (field.hasOwnProperty('prototype')) {
    data = field.data || []
  } else {
    data = field.data || field
  }
  return data.map(item => ({
    condition: item.condition.data,
    status: item.status.data,
  }))
}

export function isArray(field) {
  return Array.isArray(field) && field.length && field[0].label
}

export function isMultiCheckbox(field) {
  return (
    !Array.isArray(field) &&
    Object.keys(field).every(key => {
      return !isNaN(parseInt(key, 10))
    })
  )
}

export function isSwitch(field) {
  return field.hasOwnProperty('data') && !field.hasOwnProperty('label') && typeof field.data === 'boolean'
}

export function isInput(field) {
  return field.hasOwnProperty('data') && !field.hasOwnProperty('choices') && typeof field.data === 'string'
}

export function isSelect(field) {
  return field.hasOwnProperty('data') && field.hasOwnProperty('choices') && typeof field.data === 'string'
}

export function isMultiSelect(field) {
  return field.hasOwnProperty('data') && field.hasOwnProperty('choices') && Array.isArray(field.data)
}

export function isMultiInput(field) {
  return (
    !field.hasOwnProperty('data') &&
    Array.isArray(field) &&
    field.length &&
    field[0].data &&
    typeof field[0].data === 'string'
  )
}

export function isObject(field) {
  return !field.hasOwnProperty('data') && !Array.isArray(field) && !isMultiCheckbox(field)
}

export function flattenObject(obj) {
  var toReturn = {}
  for (var i in obj) {
    if (!obj.hasOwnProperty(i)) continue

    if (typeof obj[i] == 'object' && !Array.isArray(obj[i])) {
      var flatObject = flattenObject(obj[i])
      for (var x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue

        toReturn[i + '.' + x] = flatObject[x]
      }
    } else {
      toReturn[i] = obj[i]
    }
  }
  return toReturn
}

export function findNodeByPath(tree, path) {
  return path.reduce((acc, item) => {
    if (acc && acc.children) {
      return acc.children.find(node => node.path === item)
    } else {
      return acc.find(node => node.path === item)
    }
  }, tree)
}

export function isBonusCurrencyMap(field) {
  const rows = field && field.hasOwnProperty('prototype') ? field.data : field
  return (
    Array.isArray(rows) &&
    rows.length > 0 &&
    rows[0] &&
    typeof rows[0] === 'object' &&
    rows[0].currency &&
    rows[0].currency.hasOwnProperty('data')
  )
}

export function serializeBonusCurrencyMap(field) {
  const rows = field.hasOwnProperty('prototype') ? field.data || [] : field.data || field
  return rows.map(row => {
    const out = {}
    for (const key in row) {
      if (row.hasOwnProperty(key)) {
        out[key] = row[key].data
      }
    }
    return out
  })
}



// WEBPACK FOOTER //
// ./src/components/Projects/Form/helpers.mjs